import LogoUrl from "@/assets/XtoInfiniti-logo.png";

export default LogoUrl;
